module.exports = "<div class=\"checkout-auto-complete\">\n\t<slot\n\t\t:slotFields=\"clonedFields\"\n\t\t:isFetching=\"isFetching\"></slot>\n</div>\n"